export default "__VITE_ASSET__CV6Vx3dX__"